<section
  class="section about"
  id="about"
  tabindex="0"
>
  <div class="container">
    <div class="section-box">
      <div
        class="about-title"
        data-animate="slideInUp"
        data-animate-duration="1000"
      >
        <h3 class="section-title">
          <span class="n-section-title">01.</span>
          {{ "AboutMe.Title" | translate }}
        </h3>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 mb-4 mb-md-0">
          <div class="about-description">
            <p
              *ngFor="
                let text of 'AboutMe.Paragraphs' | translate;
                let i = index
              "
              [innerHTML]="text"
              data-animate="fadeInLeft"
              [attr.data-animate-delay]="200 + i * 300"
              data-animate-duration="800"
            ></p>
            <ul
              class="skills-list"
              data-animate="fadeInUp"
              data-animate-delay="800"
            >
              @for (item of "AboutMe.Skills" | translate; track $index) {
                <li
                  class="skill-element"
                  data-animate="scaleIn"
                  [attr.data-animate-delay]="item.Delay"
                >
                  <span class="underline">{{ item.Name }} </span>
                </li>
              }
            </ul>
          </div>
        </div>
        <div
          class="col-12 col-md-6 mt-4 mt-md-0 text-center"
          data-animate="morphIn"
          data-animate-duration="1200"
          data-animate-delay="600"
        >
          <div class="about-img-container">
            <img
              class="rounded about-image clickable"
              width="100%"
              src="assets/images/me6.jpg"
              alt="Juan David"
              title="Click para ver imagen ampliada"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal para imagen ampliada -->
  <div
    class="image-modal-overlay"
    *ngIf="isImageModalOpen"
    (click)="onModalBackdropClick($event)"
    [@fadeInOut]
  >
    <div class="image-modal-container">
      <button
        class="modal-close-btn"
        (click)="closeImageModal()"
        aria-label="Cerrar modal"
      >
        <span>&times;</span>
      </button>
      <img
        class="modal-image"
        src="assets/images/me6.jpg"
        alt="Juan David - Imagen ampliada"
        [@zoomIn]
      />
    </div>
  </div>
</section>
